import type { HTMLAttributes } from "react";
import { cn } from "./cn.ts";

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("rounded-lg border border-(--saa-border) bg-(--saa-surface) p-6 shadow-sm", className)} {...props} />;
}

export function EmptyState({ title, description, action }: { title: string; description?: string; action?: React.ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-2 rounded-lg border border-dashed border-(--saa-border) p-10 text-center">
      <p className="text-base font-medium text-(--saa-fg)">{title}</p>
      {description ? <p className="max-w-md text-sm text-(--saa-fg-muted)">{description}</p> : null}
      {action}
    </div>
  );
}
